let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("27B3z")).then(() => parcelRequire('bO8HO'));